import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserPlace, CreateUserPlaceRequest, UpdateUserPlaceRequest } from '../interfaces/user-place.interface';
import { ApiResponse } from '../interfaces/api.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanyUserPlacesService {
  private baseUrl = '/api/company/users';

  constructor(private http: HttpClient) {}

  getAll(userId: number): Observable<ApiResponse<UserPlace[]>> {
    return this.http.get<ApiResponse<UserPlace[]>>(`${this.baseUrl}/${userId}/places`);
  }

  create(userId: number, data: CreateUserPlaceRequest): Observable<ApiResponse<UserPlace>> {
    return this.http.post<ApiResponse<UserPlace>>(`${this.baseUrl}/${userId}/places`, data);
  }

  update(userId: number, placeId: number, data: UpdateUserPlaceRequest): Observable<ApiResponse<UserPlace>> {
    return this.http.put<ApiResponse<UserPlace>>(`${this.baseUrl}/${userId}/places/${placeId}`, data);
  }

  toggleActive(userId: number, placeId: number): Observable<ApiResponse<UserPlace>> {
    return this.http.patch<ApiResponse<UserPlace>>(`${this.baseUrl}/${userId}/places/${placeId}/toggle-active`, {});
  }

  delete(userId: number, placeId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${userId}/places/${placeId}`);
  }
}
